/*eslint-disable*/
import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import App from './App';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware } from 'redux';
import 'antd/dist/antd.css';
import ApplicationReducer from './store/index';
import ApiMiddleware from './middlewares/api';
import './sass/main.scss';

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}


const history = createHistory();
const routersMiddleware = routerMiddleware(history);
const store = createStore(ApplicationReducer, composeWithDevTools(applyMiddleware(thunk, routersMiddleware, ApiMiddleware)));


ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js